import styled from 'styled-components';
import { DeviceType, Orientation, WriteDirection } from 'sofa-reborn-react';
import { SkapaTheme } from '@inter-ikea-kompis/themes/lib';

type Attributes = {
	devicetype: DeviceType;
	showYmalContainer: boolean;
};

function getStyledYmal(props: Attributes): string {
	return `
		display: block;
		width: 100%;
		padding: ${props.showYmalContainer ? '0px' : `${SkapaTheme.spacing.space125}px 0`};
		min-height: ${props.devicetype === 'desktop' ? '530px' : 'initial'};
	`;
}

function getPadding(props: Attributes): string {
	return props.devicetype === 'tablet'
		? `
				padding: '0 96px';
		  `
		: ``;
}

export const StyledYmal = styled.div<Attributes>`
	${(props: Attributes): string => getStyledYmal(props)};
	${(props: Attributes): string => getPadding(props)};
`;

export const YmalHeader = styled.div`
	padding: ${SkapaTheme.spacing.space150}px;
`;

export const StyledAdditionalCover = styled.div<{
	deviceType: DeviceType;
	orientation: Orientation;
	writeDirection: WriteDirection;
}>`
	padding-right: ${(props) =>
		(props.writeDirection === 'ltr' && props.deviceType !== 'mobile') ||
		(props.orientation === 'landscape' && props.deviceType === 'mobile')
			? `${SkapaTheme.spacing.space300}px`
			: '0'};
	padding-left: ${(props) =>
		props.writeDirection === 'ltr' ||
		(props.deviceType === 'mobile' && props.orientation === 'portrait')
			? '0'
			: `${SkapaTheme.spacing.space300}px`};
	max-width: 327px;
	height: 520px;
	${(props) =>
		(props.deviceType !== 'mobile' || props.orientation === 'landscape') && 'width: 327px;'};
`;

export const StyledYmalItems = styled.div<{
	deviceType: DeviceType;
	orientation: Orientation;
}>`
	display: flex;
	flex-direction: ${(props) =>
		props.deviceType === 'mobile' && props.orientation === 'portrait' ? 'column' : 'row'};
	padding: 0 ${SkapaTheme.spacing.space125}px;
	overflow-y: auto;
`;
